import { Asterisk } from "lucide-react";

export const Marquee = ({ items }) => (
  <div className="marquee" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div className="marquee-group" key={dup}>
          {items.map((text, i) => (
            <span key={`${dup}-${i}`}>
              {text}
              <Asterisk size={22} strokeWidth={1.4} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
